if (!customElements.get('share-button')) {
  customElements.define('share-button', class ShareButton extends HTMLElement {
    constructor() {
      super();
      this.mainDetailsToggle = this.querySelector('.details');



      this.elements = {
        fallback: this.querySelector('.details'),
        shareButton: this.querySelector('button'),
        urlInput: this.querySelector('input'),
        successMessage: this.querySelector('[id^="ShareMessage"]')
      }
      this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

      if (navigator.share) {
        this.elements.fallback.setAttribute('hidden', '');
        this.elements.shareButton.classList.remove('hidden');
        this.elements.shareButton.addEventListener('click', () => { navigator.share({ url: this.urlToShare, title: document.title }) });
      } else {
        this.mainDetailsToggle
            .querySelector('.share-button__copy')
            .addEventListener('click', this.copyToClipboard.bind(this));
      }
    }

    copyToClipboard() {
      navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
        this.elements.successMessage.classList.remove('hidden');
        this.elements.successMessage.querySelector('span').textContent = window.accessibilityStrings.shareSuccess;
        setTimeout(() => {  this.elements.successMessage.classList.add('hidden'); }, 5000);

      });
    }


  

  });
}